/**
 * @generated SignedSource<<0557246e500aa3a0a936864094a38abd>>
 * @relayHash 343e33cfb92a312e723a8dccbae75141
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dcdbb5db334c688abe0f660a5583c59bf7991b656f719311fade94ccb7763612

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { decomposedStoryPointEstimateFieldQuery } from './decomposedStoryPointEstimateFieldQuery.graphql';

const node: PreloadableConcreteRequest<decomposedStoryPointEstimateFieldQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "dcdbb5db334c688abe0f660a5583c59bf7991b656f719311fade94ccb7763612",
    "metadata": {},
    "name": "decomposedStoryPointEstimateFieldQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
